import { SessionExpiredDialog } from '@rio-cloud/rio-session-expired-info';
import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';

import { getDisplayMessages, getLocale } from '../configuration/lang/langSlice';
import { getSessionExpiredAcknowledged, hideSessionExpiredDialog } from './appSlice';
import { isUserSessionExpired } from '../configuration/login/loginSlice';
import { useAppDispatch, useAppSelector } from '../configuration/setup/hooks';
import AppHeader from '../features/header/AppHeader';
import Overview from '../pages/Overview';
import PartnerSidebar from '../features/sidebar/PartnerSidebar';
import RouteUpdater from '../routes/RouteUpdater';

const OverviewApp = () => {
    const dispatch = useAppDispatch();

    const userLocale = useAppSelector(getLocale);
    const displayMessages = useAppSelector(getDisplayMessages);
    const isSessionExpired = useAppSelector(isUserSessionExpired);
    const sessionExpiredAcknowledged = useAppSelector(getSessionExpiredAcknowledged);

    if (!(displayMessages && userLocale)) {
        return null;
    }

    const handleSessionExpiredDialogClose = () => dispatch(hideSessionExpiredDialog());
    const showSessionExpired = isSessionExpired && !sessionExpiredAcknowledged;

    return (
        <>
            <ApplicationLayout.Header>
                <AppHeader />
            </ApplicationLayout.Header>
            <ApplicationLayout.Sidebar className='right'>
                <PartnerSidebar />
            </ApplicationLayout.Sidebar>
            <ApplicationLayout.Body>
                <NotificationsContainer />
                <SessionExpiredDialog
                    locale={userLocale}
                    onClose={handleSessionExpiredDialogClose}
                    show={showSessionExpired}
                />
                <Overview />
                <RouteUpdater />
            </ApplicationLayout.Body>
        </>
    );
};

export default OverviewApp;
